import { render, staticRenderFns } from "./PaDeptIndex.vue?vue&type=template&id=2456b61d&scoped=true"
import script from "./PaDeptIndex.vue?vue&type=script&lang=js"
export * from "./PaDeptIndex.vue?vue&type=script&lang=js"
import style0 from "./PaDeptIndex.vue?vue&type=style&index=0&id=2456b61d&prod&lang=css"
import style1 from "./PaDeptIndex.vue?vue&type=style&index=1&id=2456b61d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2456b61d",
  null
  
)

export default component.exports